interface ModularArchitectureSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ModularArchitectureSVG = ({
  color,
  style,
}: ModularArchitectureSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="43"
    height="50"
    viewBox="0 0 43 50"
    fill="none"
  >
    <g clipPath="url(#clip0_465_12201)">
      <path
        d="M6.08492 13.7647C6.08492 15.2885 4.84559 16.5278 3.32182 16.5278C1.79805 16.5278 0.558716 15.2885 0.558716 13.7647C0.558716 12.2409 1.79805 11.0016 3.32182 11.0016C4.84559 11.0016 6.08492 12.2409 6.08492 13.7647Z"
        stroke={color}
        strokeWidth="1.13775"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.167 24.2077C24.167 25.7315 22.9277 26.9708 21.4039 26.9708C19.8801 26.9708 18.6408 25.7315 18.6408 24.2077C18.6408 22.6839 19.8801 21.4446 21.4039 21.4446C22.9277 21.4446 24.167 22.6839 24.167 24.2077Z"
        stroke={color}
        strokeWidth="1.13775"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.2592 13.7647C42.2592 15.2885 41.0199 16.5278 39.4961 16.5278C37.9724 16.5278 36.733 15.2885 36.733 13.7647C36.733 12.2409 37.9724 11.0016 39.4961 11.0016C41.0199 11.0016 42.2592 12.2409 42.2592 13.7647Z"
        stroke={color}
        strokeWidth="1.13775"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.167 3.32194C24.167 4.84571 22.9277 6.08505 21.4039 6.08505C19.8801 6.08505 18.6408 4.84571 18.6408 3.32194C18.6408 1.79817 19.8801 0.558838 21.4039 0.558838C22.9277 0.558838 24.167 1.79817 24.167 3.32194Z"
        stroke={color}
        strokeWidth="1.13775"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.08492 36.225C6.08492 37.7488 4.84559 38.9881 3.32182 38.9881C1.79805 38.9881 0.558716 37.7488 0.558716 36.225C0.558716 34.7012 1.79805 33.4619 3.32182 33.4619C4.84559 33.4619 6.08492 34.7012 6.08492 36.225Z"
        stroke={color}
        strokeWidth="1.13775"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.4141 49.4311C22.9401 49.4311 24.1772 48.194 24.1772 46.668C24.1772 45.142 22.9401 43.9049 21.4141 43.9049C19.888 43.9049 18.651 45.142 18.651 46.668C18.651 48.194 19.888 49.4311 21.4141 49.4311Z"
        stroke={color}
        strokeWidth="1.13775"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.2592 36.225C42.2592 37.7488 41.0199 38.9881 39.4961 38.9881C37.9724 38.9881 36.733 37.7488 36.733 36.225C36.733 34.7012 37.9724 33.4619 39.4961 33.4619C41.0199 33.4619 42.2592 34.7012 42.2592 36.225Z"
        stroke={color}
        strokeWidth="1.13775"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.2844 5.56689L35.6258 11.5299"
        stroke={color}
        strokeWidth="1.13775"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.20235 11.5299L17.5437 5.56689"
        stroke={color}
        strokeWidth="1.13775"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.32182 31.5522V18.2446"
        stroke={color}
        strokeWidth="1.13775"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5335 44.4434L7.1922 38.4803"
        stroke={color}
        strokeWidth="1.13775"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.0268 22.8261L7.20235 15.9996"
        stroke={color}
        strokeWidth="1.13775"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.6258 15.9996L23.8013 22.8261"
        stroke={color}
        strokeWidth="1.13775"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.4141 26.9708V42.046"
        stroke={color}
        strokeWidth="1.13775"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.4961 31.7554V18.2446"
        stroke={color}
        strokeWidth="1.13775"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.2844 44.4535L35.6258 38.4803"
        stroke={color}
        strokeWidth="1.13775"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.8208 20.7335C31.217 21.8205 31.4405 22.9887 31.4405 24.2077C31.4405 29.226 27.7529 33.3808 22.948 34.1122"
        stroke={color}
        strokeWidth="1.13775"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6733 17.828C15.512 15.6033 18.2954 14.1812 21.4141 14.1812C24.5327 14.1812 27.2755 15.583 29.1142 17.7874"
        stroke={color}
        strokeWidth="1.13775"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.6973 34.0918C14.9736 33.2792 11.3876 29.165 11.3876 24.2076C11.3876 22.9988 11.601 21.8306 11.9972 20.7639"
        stroke={color}
        strokeWidth="1.13775"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_465_12201">
        <rect width="42.818" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default ModularArchitectureSVG;
